import { API } from "@/constant/constants"
import { MEASURE } from "@/types"
import axiosClient from "../axiosClient"

export const measureApi = {
  getAll() {
    const url = API.CONFIG_SETUP.MEASURES.DEFAULT
    return axiosClient.get<MEASURE[]>(url)
  }
}

export default measureApi;